import './styles.css';
import AppRoutes from './AppRoutes';
import { Typography } from '@material-ui/core';
import { useLocation} from 'react-router-dom';
import PageNotFound from './common/PageNotFound';
import { useAnime } from './hooks/AnimeProvider';
import { useIsMobileScreen } from './hooks/screenSizeHooks';

const AppContent = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const {anime} = useAnime();
  const isMobile = useIsMobileScreen();

  const isAllowedExactPath = pathname === '/' || pathname === '/about' || pathname === '/video_learning' || pathname === '/tune_violin' || pathname === '/pitch_tests';
  const isAllowedPathWithID = (pathname.includes('/learn/') && !!pathname.replace('/learn/', ''))
  || (pathname.includes('/practice/') && !!pathname.replace('/practice/', ''))
  || (pathname.includes('/flashcards/') && !!pathname.replace('/flashcards/', '')); 
  
  const isAllowed = isAllowedExactPath || isAllowedPathWithID;
  
  return (
    <>
      <div className={isMobile ? "wallPaperMobile" : "wallPaper"} style={{backgroundImage: 'url("/assets/images/background.jpg")'}}>
        <div className="contentContainer" style={{minHeight: '100vh', backgroundImage: `url("${anime.url}")`}}>
          {isAllowed ? 
            <AppRoutes /> 
          : <PageNotFound />
          }
        </div>
      </div>
      <Typography className="appFooter" variant="body2">© 2025 Joanne Chen. All rights reserved.</Typography>
    </>
  );
}

export default AppContent;
